import { render, staticRenderFns } from "./dataPage.vue?vue&type=template&id=648210b2&scoped=true&"
import script from "./dataPage.vue?vue&type=script&lang=js&"
export * from "./dataPage.vue?vue&type=script&lang=js&"
import style0 from "./dataPage.vue?vue&type=style&index=0&id=648210b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648210b2",
  null
  
)

export default component.exports